module.exports = __webpack_public_path__ + "img/icon5.083f02a3.jpg";